import React, { ReactElement, useEffect, useState } from 'react';
import './nhcxUserCreation.less';
import { FormTextInput } from '../../../shared/components/crmFormElement/FormInputText/FormInputText';
import { Button, Col, Form, Row } from 'antd';
import FormInputMobile from '../../../shared/components/crmFormElement/FormInputMobile/FormInputMobile';
import CustomTimeline from './customTimeline';
import { ReactComponent as RoundTickIcon } from '../../../assets/images/svg/green-filled-tick-icon.svg';
import { ReactComponent as GrayTickIcon } from '../../../assets/images/svg/Grayed_tick_icon.svg';
import NhcxOtpLogin from './NhcxOtpLogin';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchFacilityRegistry, fetchParticipantDetails,
  rollOutPayersForNHCX,
  saveParticipantDetails, setParticipantAlreadyExisting, setShowOtpScreen,
} from '../../../store/actions/nhcxAction';
import { RootState } from '../../../store';
import { NHCXState } from '../../../store/models/nhcxModel';
import {
  CONFIGURATION_VALIDATIONS, EMAIL_REGX, INDIAN_DATE_FORMAT, NHCX_REGISTRIES, NHCX_ROLES,
  createTimelineItems,
  formatMobileNumber,
} from '../../../shared/constants/commonConstants';
import { centeredNotification } from '../../../utils/utility';
import ApplicationDetail from '../../../shared/services/applicationDetail.service';
import moment from 'moment';

const NhcxUserCreation = (): ReactElement => {
  const [userCreation] = Form.useForm();
  const [disableSubmitBtn, setDisableSubmitBtn] = useState(true);
  const [showHfrId, setIsHfrId] = useState<boolean>();
  const [showMobileNo, setIsMobileNo] = useState<boolean>();
  const [showEmail, setIsEmail] = useState<boolean>();
  const [trnsactionId, setTrnsactionId] = useState('');
  const [participantID, setParticipantID] = useState('');
  const [showInitialState, setShowInitialState] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [participantData, setParticipantData] = useState({});
  const [registryData, setRegistryData] = useState({});
  const [loading, setIsLoading] = useState(false);
  const appDetail = ApplicationDetail.instance;
  const dispatch = useDispatch();
  const [fieldCompletion, setFieldCompletion] = useState({
    hfrId: false,
    mobileNumber: false,
    email: false,
    otp: false,
    verification: false,
  });
  const { showOtpScreen, participantCreated, participantExisting } = useSelector((state: RootState): NHCXState => state.nhcx);
  useEffect((): any => {
    dispatch(setParticipantAlreadyExisting(false));
    if (showOtpScreen) {
      dispatch(setShowOtpScreen(false));
    }
    dispatch(fetchParticipantDetails(appDetail?.getProviderId(),
      fetchDetailSuccess, (error: any): any => { centeredNotification(error); setParticipantData({}); }));
  }, []);

  useEffect((): any => {
    if (!showOtpScreen) {
      otpCallback(0);
      setShowDetails(false);
    }
  }, [showOtpScreen]);

  useEffect((): any => {
    if (participantCreated || participantExisting) { // to disable fields if participant is already existing or created successfully
      setIsHfrId(true);
      setIsEmail(true);
      setIsMobileNo(true);
      setShowInitialState(true);
      userCreation?.setFieldsValue({
        ['participantId']: participantID,
      });
    }
  }, [participantCreated, participantExisting]);

  const onChangeHFR = (): any => {
    if (!userCreation?.getFieldValue?.(['hfrId'])) {
      setShowDetails(false);
    }
  };

  const fetchDetailSuccess = (participantDetails?: any): any => {
    setDetails(participantDetails);
  };

  const onFieldChange = async (): Promise<void> => {
    const values = userCreation?.getFieldsValue(['email', 'mobileNumber', 'hfrId']);
    const allFieldsFilled = Object?.values?.(values)?.every((value: any): any => value !== undefined && value !== '');
    if (allFieldsFilled) {
      const errors = Object?.keys(values)?.map((key: any): any => userCreation?.getFieldError(key));
      const hasErrors = errors?.some((errorList: any): any => errorList && errorList?.length > 0);
      // Enable the button only if there are no validation errors
      setDisableSubmitBtn(hasErrors);
    } else {
      // If all fields are not filled, disable the button
      setDisableSubmitBtn(true);
    }
  };
  const onNext = (): any => {
    const payload = {
      registryType: NHCX_ROLES?.PROVIDER,
      role: NHCX_REGISTRIES?.HFR,
      email: userCreation?.getFieldValue(['email']),
      mobileNumber: userCreation?.getFieldValue(['mobileNumber'])?.replace(/\s+/g, ''),
      registryid: userCreation?.getFieldValue(['hfrId']),
    };
    setIsLoading(true);
    dispatch(saveParticipantDetails(payload, onSaveSuccess, onSaveError, onNotifyAlreadyCreated));
  };

  const onCancel = (): any => {
    userCreation?.resetFields();
    setFieldCompletion({
      hfrId: false,
      mobileNumber: false,
      email: false,
      otp: false,
      verification: false,
    });
    setIsHfrId(false);
    setIsEmail(false);
    setIsMobileNo(false);
    setShowDetails(false);
    setDisableSubmitBtn(true);
  };

  const setDetails = (participantDetails?: any): any => {
    userCreation?.setFieldsValue({
      ['hfrId']: participantDetails?.['hfrId'],
      ['email']: participantDetails?.['email'],
      ['mobileNumber']: formatMobileNumber?.(participantDetails?.['mobileNumber']),
      ['participantId']: participantDetails?.['participantId'],
    });
    if (participantDetails?.isVerified) {
      setIsHfrId(participantDetails?.hfrId ? true : false);
      setIsEmail(participantDetails?.email ? true : false);
      setIsMobileNo(participantDetails?.mobileNumber ? true : false);
      setParticipantData(participantDetails);
      if (participantDetails?.['hfrId']) {
        setShowInitialState(true);
      }
      dispatch(rollOutPayersForNHCX());
    } else {
      Object?.keys?.(participantDetails)?.forEach((key: any): any => {
        if (participantDetails?.[key]) {
          setFieldCompletion((prevState: any): any => ({ ...prevState, [key]: true }));
        }
      });
    }
    onFieldChange();
  };

  const onSaveSuccess = (transactionid: any, message: any, participantid: any): any => {
    setIsLoading(false);
    centeredNotification(message, 'success');
    setParticipantID(participantid);
    setTrnsactionId(transactionid);
    setParticipantID(participantid);
    dispatch(setShowOtpScreen(true));
  };
  const onSaveError = (error: any): any => {
    setIsLoading(false);
    centeredNotification(error, 'error');
    dispatch(setShowOtpScreen(false));
  };

  const onNotifyAlreadyCreated = (message: string, participantid: string): void => {
    centeredNotification(message, 'success'); // function to prevent otp flow if alreday participant created
    setParticipantID(participantid);
    setFieldCompletion((prevState: any): any => {
      const updatedState = Object?.keys(prevState)?.reduce((acc: any, key: any): any => {
        acc[key] = true;
        return acc;
      }, {});
      return updatedState;
    });
    dispatch(setParticipantAlreadyExisting(true));

  };
  const handleBlur = (field: string): void => {
    if (field === 'otp' && showOtpScreen) {
      setFieldCompletion((prevState: any): any => ({ ...prevState, otp: true }));
    } else {
      userCreation
        ?.validateFields([field])
        .then((): any => {
          setFieldCompletion((prevState: any): any => ({ ...prevState, [field]: true }));
        })
        .catch((): any => {
          setFieldCompletion((prevState: any): any => ({ ...prevState, [field]: false }));
        });
    }
  };

  const otpCallback = (otp: any, showField?: boolean, confirmClicked?: boolean): any => {
    setFieldCompletion((prevState: any): any => ({ ...prevState, otp: participantCreated ? true : (otp?.length === 6) }));
    setFieldCompletion((prevState: any): any => ({
      ...prevState, verification: participantCreated ? true :
        (otp?.length === 6 && showField === false && confirmClicked),
    }));
  };

  const fetchFacilityData = (facilityId: any): any => {
    if (facilityId) {
      const request = {
        facilityId,
      };
      dispatch(fetchFacilityRegistry(appDetail?.getIsVersioningPostAPIEnabled() ?
        request : facilityId, successFacilityData, errorFacilityData));
    } else {
      centeredNotification('Please enter HFR ID');
    }
  };

  const successFacilityData = (response: any): any => {
    setRegistryData(response);
    setShowDetails(true);
  };

  const errorFacilityData = (error: any): any => {
    setRegistryData({});
    setShowDetails(false);
    centeredNotification(error);
  };

  const timelineItems = createTimelineItems(fieldCompletion, <RoundTickIcon />, <GrayTickIcon />);

  return (
    <div className="container">
      <div className="flex-container w-100">

        {!showOtpScreen ?
          <div className="user-creation-cont w-70">
            <span className="ml-32">{showInitialState ? 'NHCX Participant Details' : 'Participant Creation'}</span>
            <div className="user-creation w-50">
              {!showInitialState && <p className="details p-ml-10">
                Enter below details to create your participation in NHCX System
              </p>}
              <Row className="flex flex-row align-center align-self">
                <Form form={userCreation} onFieldsChange={onFieldChange}>
                  <Col md={24} className="mb-20">
                    <span className="label">Health Facility Registry (HFR) ID</span>
                    <FormTextInput detail={{
                      key: 'hfrId',
                      form: userCreation,
                      label: 'HFR ID',
                      placeholder: 'Enter Health Facility Registry (HFR) ID',
                      hideLabel: true,
                      disabled: showHfrId,
                      rules: [{
                        required: true,
                        message: 'HFR ID is required!',
                      }],
                      size: 24,
                      onlyAlphaNumeric: true,
                      onBlur: (): any => handleBlur('hfrId'),
                      className: 'custom-placeholder',
                      onChange: onChangeHFR,
                    }} />
                  </Col>
                  <Col md={24} className="mb-20">
                    <span className="label">Mobile Number
                      <span className="label-text">(Enter mobile number registered in HFR)</span></span>
                    <FormInputMobile detail={{
                      key: 'mobileNumber',
                      label: 'Mobile No',
                      form: userCreation,
                      placeholder: 'Enter mobile number (xxxxxxxxxx)',
                      hideLabel: true,
                      allowclear: false,
                      disabled: showMobileNo,
                      prefix: '+91|',
                      showPrefix: true,
                      rules: [{
                        required: true,
                        message: 'Mobile No is required!',
                      }],
                      size: 24,
                      onBlur: (): any => handleBlur('mobileNumber'),
                      onInput: (): any => handleBlur('mobileNumber'),
                    }} />
                    {showInitialState && <p className="text-right modified-text">
                      last updated on {moment(participantData?.['date'])?.format(INDIAN_DATE_FORMAT)}</p>}
                  </Col>
                  {!showInitialState && <Col>
                    {!showDetails ?
                      <p className="avl-data">Forgot Registered Mobile Number? Click on <span onClick={(): any =>
                        fetchFacilityData(userCreation?.getFieldValue?.(['hfrId']))}><u className="underlined">
                          Fetch Details</u></span></p>
                      :
                      (showDetails) &&
                      <div className="avl-participant">
                        <p className="warning-text">
                          Please enter the complete Registered Mobile Number to Continue</p>
                        <div className="contact-details">
                          <ul>
                            <li>Hospital Name:
                              <span className="prefilled-data"> {registryData?.['facilityName']}</span></li>
                            <li>Contact Name:
                              <span className="prefilled-data"> {registryData?.['contactName']}</span></li>
                            <li>Registered Mobile Number:
                              <span className="prefilled-data"> {registryData?.['contactMobile']}</span></li>
                            <li>Registered Email Address:
                              <span className="prefilled-data"> {registryData?.['contactEmail']}</span></li>
                          </ul>
                        </div>
                      </div>
                    }
                  </Col>}
                  <Col md={24} className="mb-20">
                    <span className="label">
                      Email Address <span className="label-text">(Enter email address registered in HFR)</span></span>
                    <FormTextInput detail={{
                      key: 'email',
                      label: 'Email Id',
                      form: userCreation,
                      placeholder: 'Enter Email Address',
                      hideLabel: true,
                      disabled: showEmail,
                      rules: [
                        {
                          required: true,
                          message: `Email Id is required!`,
                        },
                        {
                          pattern: EMAIL_REGX,
                          message: CONFIGURATION_VALIDATIONS.primaryMailIdPattern,
                        },
                        { max: 50, message: CONFIGURATION_VALIDATIONS.emailIdCharLimit },
                      ],
                      size: 24,
                      onBlur: (): any => handleBlur('email'),
                      isMaxLengthNotApplicable: true,
                    }} />
                    {showInitialState && <p className="text-right modified-text">
                      last updated on {moment(participantData?.['date'])?.format(INDIAN_DATE_FORMAT)}</p>}
                  </Col>
                  {((showInitialState && participantData?.['participantId']) ||
                    (participantCreated || participantExisting)) && <Col md={24} className="mb-20">
                      <span className="label">
                        Participant ID</span>
                      <FormTextInput detail={{
                        key: 'participantId',
                        label: 'Participant Id',
                        form: userCreation,
                        placeholder: 'Enter Participant Id',
                        hideLabel: true,
                        disabled: true,
                        rules: [
                          {
                            required: true,
                            message: `Participant Id is required!`,
                          },
                        ],
                        size: 24,
                        isMaxLengthNotApplicable: true,
                      }} />
                      {showInitialState && <p className="text-right modified-text">
                        last updated on {moment(participantData?.['date'])?.format(INDIAN_DATE_FORMAT)}</p>}
                    </Col>}
                  {!showInitialState && <div className="btn">
                    <Button className="ghost-primary-btn no-border bold width-100"
                      type="ghost" size="middle" onClick={onCancel}>Cancel</Button>
                    <Button className="nxt-btn width-100"
                      type="primary" size="middle" disabled={disableSubmitBtn} loading={loading}
                      onClick={onNext}>Next</Button>
                  </div>}
                </Form>
              </Row>
            </div>
          </div> :
          <NhcxOtpLogin showOtp={showOtpScreen} formValues={userCreation} otpCallback={otpCallback}
            trnsactionId={trnsactionId} userCreation={userCreation} participantID={participantID}
            setTrnsactionId={setTrnsactionId} />
        }
        {!showInitialState && <div className="status-timeline w-30 blue"><span>Steps for NHCX Participant Creation</span>
          <CustomTimeline items={timelineItems} className="details" />
        </div>}
      </div>
    </div>
  );
};
export default NhcxUserCreation;
